import { Intervention } from '@/app/components/action-plan/types';

type InterventionWithRiskData = Intervention & {
  affectedCancersCount: number;
  highestImpact: number;
  hasOverallRisk: boolean;
};

export function sortInterventions(a: InterventionWithRiskData, b: InterventionWithRiskData) {
  if (b.affectedCancersCount !== a.affectedCancersCount) {
    return b.affectedCancersCount - a.affectedCancersCount;
  }
  if (b.highestImpact !== a.highestImpact) {
    return b.highestImpact - a.highestImpact;
  }
  return a.hasOverallRisk ? -1 : 1;
}
